<template>
    <b-container>
        <b-tabs v-model="currentTab" align="center">
            <b-tab title="Alle">
                <b>Projektgruppen</b>
                <br>
                <b-table responsive small :items="projectGroups" :fields="fields" :tbody-tr-class="rowClass" hover>
                    <template slot="index" slot-scope="data">
                        {{ data.index }}
                    </template>

                    <template slot="members" slot-scope="data">
                        {{ data.item.members.join() }}
                    </template>

                    <template slot="action" slot-scope="data">
                        <b-dropdown text="Aktion">
                            <b-dropdown-item @click="editProjectGroupItem(data.item)">Bearbeiten</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item @click="deleteProjectGroup(data.item.id)">Löschen</b-dropdown-item>
                        </b-dropdown>
                    </template>
                </b-table>
                <div class="text-right">
                    <b>{{ 'pagination.page' | translate(currentPageDisplay, totalPagesDisplay) }}</b>
                </div>
                <ul class="pagination">
                    <li
                        class="pagination-item"
                    >
                        <b-button
                            variant="outline-secondary"
                            @click="onClickFirstPage"
                            v-bind:aria-label="$globalStore.translate('pagination.page.first.text')"
                        >
                            << {{ 'pagination.page.first' | translate }}
                        </b-button>
                    </li>

                    <li
                        class="pagination-item"
                    >
                        <b-button
                            variant="outline-secondary"
                            @click="onClickPreviousPage"
                            v-bind:aria-label="$globalStore.translate('pagination.page.previous.text')"
                        >
                            < {{ 'pagination.page.previous' | translate }}
                        </b-button>
                    </li>
                    <li class="pagination-item">
                        <b-button
                            variant="outline-secondary"
                            @click="onClickNextPage"
                            v-bind:aria-label="$globalStore.translate('pagination.page.next.text')"
                        >
                            {{ 'pagination.page.next' | translate }} >
                        </b-button>
                    </li>

                    <li class="pagination-item">
                        <b-button
                            variant="outline-secondary"
                            @click="onClickLastPage"
                            v-bind:aria-label="$globalStore.translate('pagination.page.last.text')"
                        >
                            {{ 'pagination.page.last' | translate }} >>
                        </b-button>
                    </li>
                </ul>
            </b-tab>
            <b-tab title="Hinzufügen">
                <b>Projektgruppe hinzufügen</b>
                <br>
                <b-alert variant="danger" dismissible @dismissed="status = ''" :show="status.length > 0">{{ status }}</b-alert>
                <b-form @submit.prevent="addProjectGroup" @reset.prevent="cancelAddProjectGroup">
                    <b-form-group
                        label="Name"
                        label-for="inputName"
                    >
                        <b-form-input id="inputName" type="text" :state="newNameState" v-model="newProjectGroup.name"></b-form-input>

                        <b-form-invalid-feedback>
                            Mindestens 3 und maximal 15 Buchstaben.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <multiselect v-model="newProjectGroup.members"
                                 :options="members"
                                 :multiple="true"
                                 :close-on-select="false"
                                 v-bind:placeholder="$globalStore.translate('project.groups.members.placeholder')"
                                 v-bind:selectLabel="$globalStore.translate('home.selection.select.label')"
                                 v-bind:selectedLabel="$globalStore.translate('home.selection.selected.label')"
                                 v-bind:selectGroupLabel="$globalStore.translate('home.selection.select.group.label')"
                                 v-bind:deselectLabel="$globalStore.translate('home.selection.deselect.label')"
                                 v-bind:deselectGroupLabel="$globalStore.translate('home.selection.deselect.group.label')"
                                 v-on:open="loadUsers"
                    >

                    </multiselect>

                    <b-button type="submit" variant="primary" class="float-right">Hinzufügen</b-button>
                    <b-button type="reset" variant="secondary" class="float-right">Abbrechen</b-button>
                </b-form>
            </b-tab>
            <b-tab title="Bearbeiten" v-if="editProjectGroup.id !== -1">
                <b>Projektgruppe bearbeiten</b>
                <br>
                <b-alert variant="danger" dismissible @dismissed="status = ''" :show="status.length > 0">{{ status }}</b-alert>
                <b-form @submit.prevent="saveEditProjectGroup" @reset.prevent="cancelEditProjectGroup(); currentTab = 0;">
                    <b-form-group
                        label="Name"
                        label-for="inputNameEdit"
                    >
                        <b-form-input id="inputNameEdit" type="text" :state="editNameState" v-model="editProjectGroup.name"></b-form-input>

                        <b-form-invalid-feedback>
                            Mindestens 3 und maximal 15 Buchstaben.
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <multiselect v-model="editProjectGroup.members"
                                 :options="members"
                                 :multiple="true"
                                 :close-on-select="false"
                                 v-bind:placeholder="$globalStore.translate('project.groups.members.placeholder')"
                                 v-bind:selectLabel="$globalStore.translate('home.selection.select.label')"
                                 v-bind:selectedLabel="$globalStore.translate('home.selection.selected.label')"
                                 v-bind:selectGroupLabel="$globalStore.translate('home.selection.select.group.label')"
                                 v-bind:deselectLabel="$globalStore.translate('home.selection.deselect.label')"
                                 v-bind:deselectGroupLabel="$globalStore.translate('home.selection.deselect.group.label')"
                                 v-on:open="loadUsers"
                    >

                    </multiselect>

                    <b-button type="submit" variant="primary" class="float-right">Speichern</b-button>
                    <b-button type="reset" variant="secondary" class="float-right">Abbrechen</b-button>
                </b-form>
            </b-tab>
        </b-tabs>
    </b-container>
</template>

<script>
    import axios from 'axios'
    import Multiselect from 'vue-multiselect'

    export default {
        name: "ProjectGroups",
        components: {
            Multiselect
        },
        data() {
            return {
                currentTab: 0,
                projectGroups: [],
                fields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: 'Name',
                    },
                    {
                        key: 'members',
                        label: 'Mitglieder',
                    },
                    {
                        key: 'action',
                        label: 'Aktion',
                    }
                ],
                members: [],
                newProjectGroup: {
                    name: '',
                    members: []
                },
                editProjectGroup: {
                    id: -1,
                    name: '',
                    members: [],
                    oldMembers: null
                },
                currentPage: 1,
                currentPageDisplay: 1,
                totalPages: 1,
                totalPagesDisplay: 1,
                status: ''
            }
        },
        methods: {
            onClickFirstPage: function () {
                this.currentPage = 1;

                this.getProjectGroups();
            },
            onClickLastPage: function () {
                this.currentPage = 0;

                this.getProjectGroups();
            },
            onClickNextPage: function () {
                this.currentPage++;

                this.getProjectGroups();
            },
            onClickPreviousPage: function () {
                this.currentPage--;

                this.getProjectGroups();
            },
            getProjectGroups: function () {
                axios.get('https://drop.rautec.de/api/projectGroups/' + this.currentPage).then(response => {
                    if (response.data.projectGroups) {
                        this.projectGroups = response.data.projectGroups;
                    }

                    this.currentPage = response.data.currentPage;
                    this.currentPageDisplay = response.data.currentPage;
                    this.totalPages = response.data.totalPages;
                    this.totalPagesDisplay = response.data.totalPages;
                });
            },
            deleteProjectGroup: function (projectGroupId) {
                axios.delete('https://drop.rautec.de/api/projectGroups/' + projectGroupId).then(response => {
                    if (response.data.error === 0) {
                        this.$toastSuccess('Projektgruppe erfolgreich gelöscht.');

                        this.getProjectGroups();
                    } else {
                        this.$toastError('Projektgruppe konnte nicht gelöscht werden.');
                    }
                }).catch(reason => {
                    this.$toastError('Fehler bei der Abfrage.');
                });
            },
            editProjectGroupItem: function (projectGroup) {
                this.editProjectGroup.id = projectGroup.id;
                this.editProjectGroup.name = projectGroup.name;
                this.editProjectGroup.members = projectGroup.members;
                this.editProjectGroup.oldMembers = this.editProjectGroup.members;

                setTimeout(() => {
                    this.currentTab = 2;
                }, 25);
            },
            saveEditProjectGroup: function () {
                if (this.editProjectGroup.members.length === 0) {
                    this.status = 'Bitte fügen Sie mindestens ein Mitglied hinzu.';
                    return;
                }

                if (this.editProjectGroup.name.length < 3 || this.editProjectGroup.name.length > 15) {
                    return;
                }

                this.status = '';

                let addedMembers = [];
                let removedMembers = [];

                for (let i = 0; i < this.editProjectGroup.members.length; i++) {
                    if (!this.editProjectGroup.oldMembers.includes(this.editProjectGroup.members[i])) {
                        addedMembers.push(this.editProjectGroup.members[i]);
                    }
                }

                for (let i = 0; i < this.editProjectGroup.oldMembers.length; i++) {
                    if (!this.editProjectGroup.members.includes(this.editProjectGroup.oldMembers[i])) {
                        removedMembers.push(this.editProjectGroup.oldMembers[i]);
                    }
                }

                // Update the old members to be able to edit the project group again, without switching the menu
                this.editProjectGroup.oldMembers = this.editProjectGroup.members;

                axios.put('https://drop.rautec.de/api/projectGroups/' + this.editProjectGroup.id, {
                    id: this.editProjectGroup.id,
                    name: this.editProjectGroup.name,
                    removedMembers: removedMembers,
                    addedMembers: addedMembers
                }).then(response => {
                    if (response.data.error === 0) {
                        this.$toastSuccess('Projektgruppe erfolgreich gespeichert.');

                        this.getProjectGroups();

                        this.cancelEditProjectGroup();

                        this.currentTab = 0;
                    } else if (response.data.error === 1) {
                        this.$toastError('Projektgruppe mit dem Namen existiert bereits.');
                    } else {
                        this.$toastError('Projektgruppe konnte nicht gespeichert werden.');
                    }
                }).catch(reason => {
                    this.$toastError('Fehler bei der Abfrage.');
                })
            },
            cancelEditProjectGroup: function () {
                this.editProjectGroup.id = -1;
                this.editProjectGroup.name = '';
                this.editProjectGroup.members = [];
            },
            addProjectGroup: function () {
                if (this.newProjectGroup.members.length === 0) {
                    this.status = 'Bitte fügen Sie mindestens ein Mitglied hinzu.';
                    return;
                }

                if (this.newProjectGroup.name.length < 3 || this.newProjectGroup.name.length > 15) {
                    return;
                }

                this.status = '';

                let formData = new FormData();
                formData.append('name', this.newProjectGroup.name);
                for (let i = 0; i < this.newProjectGroup.members.length; i++) {
                    formData.append('members[' + i + ']', this.newProjectGroup.members[i]);
                }

                axios.post('https://drop.rautec.de/api/projectGroups', formData).then(response => {
                    if (response.data.error === 0) {
                        this.$toastSuccess('Projektgruppe erfolgreich hinzugefügt.');

                        this.newProjectGroup.name = '';
                        this.newProjectGroup.members = null;

                        this.getProjectGroups();

                        this.cancelAddProjectGroup();
                    } else if (response.data.error === 1) {
                        this.$toastError('Projektgruppe mit dem Namen existiert bereits.');
                    } else {
                        this.$toastError('Projektgruppe konnte nicht hinzugefügt werden.');
                    }
                }).catch(reason => {
                    this.$toastError('Fehler bei der Abfrage.');
                });
            },
            cancelAddProjectGroup: function () {
                this.newProjectGroup.name = '';
                this.newProjectGroup.members = [];

                this.currentTab = 0;
            },
            loadUsers: function () {
                // Only if members are not already loaded to save requests
                if (this.members.length === 0) {
                    axios.get('https://drop.rautec.de/api/users/customers').then(response => {
                        if (response.data.customers) {
                            this.members = this.members.concat(response.data.customers);
                        }
                    });

                    axios.get('https://drop.rautec.de/api/users/employees').then(response => {
                        if (response.data.employees) {
                            this.members = this.members.concat(response.data.employees);
                        }
                    });
                }
            }
        },
        watch: {
            currentTab: function (value, oldValue) {
                // If the tab is switched and was the edit project group before, reset the edit project group
                if (oldValue === 2) {
                    this.cancelEditProjectGroup();
                }
            },
        },
        computed: {
            newNameState() {
                return this.newProjectGroup.name.length > 2 && this.newProjectGroup.name.length < 16;
            },
            editNameState() {
                return this.editProjectGroup.name.length > 2 && this.editProjectGroup.name.length < 16;
            }
        },
        mounted() {
            this.getProjectGroups();
        }
    }
</script>

<style scoped>
    .pagination {
        list-style-type: none;
        display: flex;
        justify-content: center;
    }

    .pagination-item {
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/ProjectGroups.vue